/*!
 * Copyright (c) 2023 Bolmate B.V.
 */

@use '../../../../../style/common-variables' as commons;
@use '../../../../../style/dimensions';
@use '../../../../../style/color-functions' as *;

.bolmate-radio {
  cursor: pointer;
  display: grid;
  grid-template-columns: repeat(2, fit-content(100%));
  align-items: center;
  grid-column-gap: 0.5rem;

  // The bullet is 20px; on touch the row carries the ergonomic minimum so the
  // whole option — not just the dot — is a reliable target.
  @include dimensions.touch-input {
    min-height: dimensions.$touch-target-min;
  }

  .bolmate-radio-bullet-container {
    $size: 20px;
    width: $size;
    height: $size;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid commons.$color-blue-bolmate;
    border-radius: 50%;
    transition: border-color 0.2s ease-in-out;

    .bolmate-radio-bullet {
      background-color: commons.$color-blue-bolmate;
      width: calc($size / 2);
      height: calc($size / 2);
      border-radius: 50%;
      display: block;
      visibility: hidden;
      opacity: 0;
      transition:
        visibility 0.2s ease-in-out,
        opacity 0.2s ease-in-out,
        background-color 0.2s ease-in-out;

      &.active {
        visibility: visible;
        opacity: 1;
      }
    }
  }

  &:hover {
    .bolmate-radio-bullet-container {
      border-color: darken(commons.$color-blue-bolmate, 10%);

      .bolmate-radio-bullet {
        background-color: darken(commons.$color-blue-bolmate, 10%);
      }
    }
  }

  &.disabled {
    cursor: default;
    .bolmate-radio-bullet-container {
      border-color: commons.$color-gray-4;

      .bolmate-radio-bullet {
        background-color: commons.$color-gray-4;
      }
    }
  }
}
